import posthog from 'posthog-js';

export default {
  install(Vue) {
    if (process.env.VUE_APP_POSTHOG_API_KEY) {
      posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2025-05-24',
        person_profiles: 'identified_only',
        capture_exceptions: true,
      });
    }

    Vue.prototype.$posthog = posthog;
  },
};
